'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCookie = getCookie;
exports.setCookie = setCookie;
function getCookie(key) {
    return document.cookie.replace(new RegExp('(?:(?:^|.*;\\s*)' + key + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1');
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    if (exdays) {
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    } else {
        document.cookie = cname + '=' + cvalue + ';path=/';
    }
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/util/cookies.js
// module id = ./resources/assets/js/src/util/cookies.js
// module chunks = 0